import React from "react";
import { useAtom } from "jotai";
import { activeProvidersAtom, providersAtom } from "../state/games";
import Icon from "./Icon";
import { CloseIcon } from "./Icons";

const FiltersSelected = () => {
    const [providers] = useAtom(providersAtom);
    const [activeProviders, setActiveProviders] = useAtom(activeProvidersAtom);

    const filtered = providers?.filter(option => activeProviders.includes(option.id));

    const removeFilter = (provider_id: number) => {
        const filtered = activeProviders.filter(option => option !== provider_id);
        setActiveProviders(filtered);
    };
    return (
        <>
            {filtered &&
                filtered.map(provider => {
                    return (
                        <div
                            key={`filter-selected-${provider.id}`}
                            className="filter-option provider"
                            onClick={() => removeFilter(provider.id)}
                        >
                            <span className="filter-option-title provider-title">
                                {provider.name}
                            </span>
                            <Icon icon={CloseIcon} />
                        </div>
                    );
                })}
        </>
    );
};

export default FiltersSelected;
